import { SpaceActionContribution } from '@/services/space-action-contribution';
import { createDialog } from '@/infrastructure/decorators/dialog';
import { CommandContribution } from '@patsnap/tahiti-core/common/command';
import { CropImageService } from './crop-image-service';
import { CropImageServiceImp } from './crop-image-service.imp';
import { EditSpaceContribution, RequestSpaceEditDataService } from './edit-space-contribution';
import { SpaceCoverImageReader } from './space-cover-image-reader';
import { SpaceCoverImageReaderImp } from './space-cover-image-reader.imp';
import { SpaceTemplateAlertServiceImpl } from './space-template-alert-service';
import { SpaceTemplateAlertService } from './space-template-alert-service.interface';
export function editSpaceModule(bind) {
    bind(CommandContribution).to(EditSpaceContribution);
    bind(SpaceActionContribution).to(EditSpaceContribution);
    // utils:
    bind(SpaceCoverImageReader).to(SpaceCoverImageReaderImp);
    bind(CropImageService).to(CropImageServiceImp);
    bind(RequestSpaceEditDataService)
        .toDynamicValue(createDialog(() => import('@/presentation/components/workspaces/EditWorkspaceDialogNew.vue')));
    bind(SpaceTemplateAlertService).to(SpaceTemplateAlertServiceImpl);
}
